<template>
  <div class="product-prices">
    <input type="hidden" name="options" v-model="optionsImploded" />

    <div class="model" v-for="(model, index) in product.options">
      <div class="model-name">
        <span class="model-name-subtitle">
          Model
        </span>
        <input v-model="model.ProductCode"
               type="text"
               class="dark-grey-input model-input"
               placeholder="Model Code"
        />

        <button class="btn btn-sm btn-danger action"
                type="button"
                @click="remove(index)">
          <ion-icon name="remove-circle"></ion-icon>
        </button>
      </div>

      <textarea class="form-control"
                v-model="model.ProductDescription"
                placeholder="Model description"
                rows="5"
      ></textarea>

      <div class="prices">
        <div class="price">
          <div class="label">Retail price, $</div>
          <input v-model="model.DefaultSellPrice" :name="'retail_price-' + index" type="number" class="form-control" step="1" min="0" />
        </div>
        <div class="price">
          <div class="label">Special price, $</div>
          <input v-model="model.SpecialPrice" :name="'dealer_price-' + index" type="number" class="form-control" step="1" min="0" />
        </div>
        <div class="price dates">
          <div class="date date-from">
            <div class="label">Special price valid from:</div>
            <datetime format="DD/MM/YYYY"
                      v-model="model.SpecialPriceDateFrom"
            />
          </div>
          <div class="date date-to">
            <div class="label">Special price valid until:</div>
            <datetime format="DD/MM/YYYY"
                      v-model="model.SpecialPriceDateTo"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <button class="button button-primary" type="button" @click="add">
        <ion-icon name="add-circle"></ion-icon>
        Add model
      </button>
    </div>
  </div>
</template>

<script>
import datetime from 'vuejs-datetimepicker'

export default {
  name: "ProductPrices",
  props: ['product'],
  components: {
    datetime
  },
  data(){
    return {
      models: [],
    }
  },
  mounted() {
  },
  methods: {
    add(){
      this.product.options.push({
        ProductDescription: "",
        DefaultSellPrice: 0,
        NettPrice: 0,
      })
    },
    remove(index){
      let model = this.product.options[index]
      if(!model){
        return
      }

      if(!model.ProductDescription && !model.DefaultSellPrice && !model.NettPrice){
        return this.product.options.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this model?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.product.options.splice(index, 1)
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    }
  },
  computed: {
    optionsImploded(){
      return JSON.stringify(this.product.options)
    }
  }
}
</script>

